export default {
    methods: {
        fmt1(value)
        { 
          if(!isNaN(value))
          {
            return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
          }
        },
        fmt2(value)
        { 
          if(!isNaN(value))
          {
          return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 0 ,maximumFractionDigits: 0});
          }
        }, 
        fmtDate()
        {
         
          const event = new Date(Date.now());
          
          const fmtDate = event.toLocaleString()
          return fmtDate
        }
    }


    

}